import { getCartTotal } from "../../../../Services/Ecommerce.service";
import { Price, ProductName, Quantity, Sub_total } from "../../../../Constant";
import { H6, P } from "../../../../AbstractElements";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceDescription from "./InvoiceDescription";
import PrintInvoice from "./PrintInvoice";
import { Col, Label, Row, Table, Container, CardBody, Card } from "reactstrap";
import React, { Component, Fragment } from "react";
import InvoiceDetails from "./InvoiceDetails";
import DataTable from "react-data-table-component";
import { AppointmentPaymentList } from "../../../../apiController";

class ItemDescription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientPaymentList: [],
    };
  }

  async componentDidMount() {
    const { data } = this.props;
    const patientId = data.id;
    await this.fetchPatientAppointmentPaymentList(patientId);
  }

  fetchPatientAppointmentPaymentList = async (id) => {
    try {
      const response = await AppointmentPaymentList({ patient_id: id });
      if (response.status === true) {
        const patientPaymentData = response.data;
        console.log(patientPaymentData);
        this.setState({ patientPaymentList: patientPaymentData });
      }
    } catch (error) {
      console.error("Error fetching patient payment data:", error);
    }
  };
  render() {
    const { cart, symbol, rowData, data } = this.props;

    const { patientPaymentList } = this.state;
    const filteredPayments = patientPaymentList.filter(
      (r) => r.date === rowData.date
    );

    const treatmenttabledata = filteredPayments.flatMap((row, ind) => {
      const patientTreatments = row.payment.flatMap((d) =>
        d.services.flatMap((trt) => JSON.parse(trt.patient_treatment))
      );

      return patientTreatments.map((patientTreatment, ind) => ({
        ind: ind + 1,
        id: row.id,
        // date: row.date,
        type:
          patientTreatment.type === "tooth" ? (
            <p>{patientTreatment.tooth}</p>
          ) : (
            patientTreatment.type
          ),
        diagnosis: patientTreatment.problem
          ? patientTreatment.problem.name
          : "-",
        method: patientTreatment.itemsPr
          ? patientTreatment.itemsPr.map((t) => t.mname).join(", ")
          : "-",
      }));
    });

    const tableColumns = [
      {
        name: "#",
        selector: (row) => row["ind"],
        sortable: true,
        center: false,
      },
      // {
      //     name: 'Date',
      //     selector: row => row['date'],
      //     sortable: true,
      //     center: false,
      // },
      {
        name: "Type",
        selector: (row) => row["type"],
        sortable: true,
        center: true,
      },
      {
        name: "Diagnosis",
        selector: (row) => `${row.diagnosis}`,
        sortable: true,
        center: true,
      },
      {
        name: "Treatment Done",
        selector: (row) => `${row.method}`,
        sortable: true,
        center: true,
      },
    ];

    return (
      <Fragment>
        <div className="p-3 m-0">
          <Container fluid>
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <div className="invoice">
                      <div>
                        <InvoiceHeader data={data} rowData={rowData} />
                        <InvoiceDescription data={data} rowData={rowData} />
                        <div
                          className="table-responsive invoice-table"
                          id="table"
                        >
                          <DataTable
                            className="mt-5"
                            data={treatmenttabledata}
                            columns={tableColumns}
                            striped={true}
                            center={true}
                            // pagination
                            responsive
                          />
                        </div>
                        <div className="mb-5 mt-5">
                          <InvoiceDetails
                            data={data}
                            rowData={rowData}
                            filterData={filteredPayments}
                          />
                        </div>
                        <PrintInvoice />
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Fragment>
    );
  }
}

export default ItemDescription;
